<template>
  <div class="subscription-success-container">
    <p>Thanks for subscribing!</p>
    We want to see you double your product sales!
  </div>
</template>

<script>
export default {
  name: 'SubscriptionSuccess',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.subscription-success-container {
  padding: 50px 0px;
}
</style>